import BaseModel from './BaseModel';
import Classroom from './Classroom';
import moment from 'moment';
import i18n from '../locales/i18n';
import _ from 'lodash';

/** Class representing a course. */
class Course extends BaseModel {
    static ATTENDANCE_NONE    = 'none';
    static ATTENDANCE_PRESENT = 'present';
    static ATTENDANCE_ABSENT  = 'absent';

    constructor(properties) {
        super(properties);

        this.start_at = moment(this.start_at);
        this.stop_at  = moment(this.stop_at);

        if (this.classroom)
            this.classroom = new Classroom(this.classroom);

        if (this.attendances)
            this.attendances = _.sortBy((this.attendances || []), 'student.lastname');
    }

    canBeRollCalled() {
        if (this.start_at.isBefore(moment()))
            return true;

        if (this.start_at.isSame(moment(), 'day'))
            return true;

        return false;
    }

    hasBeenRollCalled() {
        return this.canBeRollCalled() && this.attendances?.length > 0;
    }

    getDateText() {
        return this.start_at.format('dddd D MMM').replace(/^./, str => str.toUpperCase());
    }

    getTimeText() {
        return this.start_at.format('LT') + ' - ' + this.stop_at.format('LT');
    }
}

export default Course;
